import { StyleSheet } from 'react-native';

import { colors } from '../../colors';

export const styles = StyleSheet.create({
  button: {
    alignItems: 'center',
    backgroundColor: colors.actionBackground,
    borderRadius: 8,
    paddingVertical: 10
  },
  buttonPressed: {
    opacity: 0.8
  },
  buttonText: {
    color: colors.actionText,
    fontWeight: '600'
  },
  card: {
    backgroundColor: colors.cardBackgroundDark,
    borderRadius: 12,
    gap: 8,
    padding: 16
  },
  metaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  metaText: {
    color: colors.textMuted,
    fontSize: 12
  },
  subtitle: {
    color: colors.textSubtle,
    fontSize: 14
  },
  timestamp: {
    color: colors.textTimestamp,
    fontSize: 11
  },
  title: {
    color: colors.actionBackground,
    fontSize: 20,
    fontWeight: '700'
  }
});
